import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/header.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/[lang]/layout.js\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"700\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
